<template>
  <div class="student-rest-list">
    <div v-if="studentList.length" class="box-conten">
      <div v-for="(item, index) in studentList" :key="index">
        <div v-if="item" class="state-type-box">
          <div v-for="(item_min, index_min) in item" :key="index_min" class="rest-item"
            :class="{ active: index_min + 1 !== item.length }">
            <div class="pic-box">
              <img :src="item_min.teacherPic" alt="">
            </div>
            <div class="text-content">
              <div class="name-text"><Icon type="logo-octocat"  size="22" color="#ffc524f0"/><span class="name">&#160&#160{{ item_min.name }} </span></div>
              <div class="time"><Icon type="ios-clock-outline" size="22" color="#ffc524f0" />&#160&#160{{ item_min.vacateTime }} </div>
              <div class="type"><Icon type="ios-pricetags-outline" size="22" color="#ffc524f0"  />&#160&#160{{ item_min.type }} </div>
              <div class="textarea">
                <div class="textarea-title"><Icon type="ios-chatboxes-outline" size="22" color="#ffc524f0" /></div>
                <div class="textarea-content"> &#160&#160{{ item_min.textarea }} </div>
              </div>
            </div>
            <div class="state" :style="{ backgroundColor: colorList[item_min.state] }"> {{ getState(item_min.state) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn" @click="goView('/user/student/taskOf', true)"> 新增请假单 </div>
  </div>
</template>

<script>
import { getLeaveFormerly } from '@api/user'

import { sort } from '@common'

export default {
  name: 'StudentRest-list',
  data() {
    return {
      studentList: [],
      colorList: ['rgb(228, 228, 222)', '#2980f7', 'rgb(171 69 83)']
    }
  },
  created() {
    this.getRestSutdentData();
  },
  methods: {
    /**
     * 页面跳转
     */
    goView(path, state) {
      if (path) {
        if (this.$route.params.uid && state) {
          this.$router.push(path + '/' + this.$route.params.uid);
        } else if (!state) {
          this.$router.push(path);
        }
      }
    },
    getState(state) {
      if (!state) {
        return '审批中';
      } else if (state === 1) {
        return '已同意';
      } else if (state === 2) {
        return '已拒绝';
      }
    },
    /**
     * 获取学生请假信息
     */
    getRestSutdentData() {
      getLeaveFormerly(this.$route.params.uid).then(res => {
        let resList = res.data.data;
        let arrStore = []
        let arr = [[], [], []]
        for (let item of resList) {
          arrStore.push({
            name: item.vacate_name,
            type: item.type,
            textarea: item.cause,
            addTime: item.addTime,
            vacateTime: item.vacate_time,
            teacherPic: item.avatar,
            state: item.status //审批状态
          })
        }
        sort(arrStore, 'addTime');
        for (let item of arrStore) {
          if (!item.state) { //审批中
            arr[0].push(item);
          } else if (item.state === 1) { //审批成功
            arr[1].push(item);
          } else if (item.state === 2) { //审批失败
            arr[2].push(item);
          }
        }
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].length) {
            arr2[i] = arr[i]
          }
        }
        this.studentList = arr2;
      })
    }
  }
}
</script>

<style scoped>
.student-rest-list {
  position: relative;
  width: 100vw;
  height: 100vh;
  padding: 0.2rem 0.2rem;
  overflow-y: scroll;
  padding-bottom: 1.5rem;
  border-radius: 15px;
  /* box-shadow: .1rem 2.1rem 2.1rem rgb(214, 212, 212); */
}

.state-type-box {
  height: auto;
  padding: 0.2rem;
  border-radius: 0.2rem;
  background-color: white;
  margin-bottom: 0.2rem;
  box-shadow: 0.13rem 0.2rem 0.1rem rgb(177, 176, 176);
}

.rest-item {
  display: flex;
  align-items: center;
  padding: 0.2rem;
}

.text-content {
  flex: 1;
}

.pic-box {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.4rem;
  border-radius: 0.2rem;
  overflow: hidden;
}

.pic-box img {
  height: 100%;
  width: 100%;
}

.name {
  color: #ffb444;
}

.textarea {
  display: flex;
  padding-right: 0.2rem;
}

.textarea-content {
  flex: 1;
  width: 2.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.text-content::-webkit-scrollbar {
  display: none;
}

.state {
  padding: 0.05rem 0.1rem;
  background-color: rgb(255, 255, 255);
  color: rgb(250, 250, 250);
  border-radius: 0.2rem;
}

.active {
  border-bottom: 1px solid rgb(202, 202, 202);
}

.btn {
  width: 40vw;
  height: 0.8rem;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #2980f7;
  color: rgb(255, 255, 255);
  position: fixed;
  left: 30vw;
  bottom: 60px;
}</style>